import React, { Suspense, lazy } from "react";
import styled from "styled-components";
import Typography from "@material-ui/core/Typography";
import { Box, Tabs, Tab } from "@material-ui/core";
import { withTheme } from "@material-ui/styles";
import SearchByVIN from "./SearchByVIN";
import YMMTFormContainer from "../containers/YMMTFormContainer";
import YMMTFormSkeleton from "../components/YMMTFormSkeleton";

const YMMTForm = lazy(() => import("../components/YMMTForm"));

export const SearchByHeader = styled(Typography).attrs({
  variant: "h4",
  color: "textSecondary",
})`
  && {
    font-weight: 300;
    margin-bottom: 10px;
  }

  > strong {
    font-weight: 550;
  }
`;

const Wrapper = withTheme(styled.div`
  background-color: rgba(255, 255, 255, 1);
  border: 1px solid #cecece;
  width: 100%;
  box-sizing: border-box;
  border-radius: 10px;
  overflow: hidden;
  max-width: 500px;
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.1), 0 10px 10px rgba(0, 0, 0, 0.08);
`);

const TabPanelWrapper = styled.div`
  padding: 25px;
`;

const TabHeader = styled(Typography).attrs({
  variant: "h6",
  color: "textSecondary",
})`
  && {
    font-weight: 550;
  }
`;

const StyledTabs = styled((props) => (
  <Tabs
    {...props}
    TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
  />
))({
  "& .MuiTabs-indicator": {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
  },
  "& .MuiTabs-indicatorSpan": {
    width: "70%",
    backgroundColor: "rgb(48,170,231)",
  },
});

const StyledTab = styled(Tab)`
  height: 65px;
  background-color: #f0f0f0 !important;

  &.Mui-selected {
    background-color: white !important;
  }
`;

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <TabPanelWrapper>{children}</TabPanelWrapper>}
    </div>
  );
};

const Search = ({ handleOnSubmit, accountId }) => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Wrapper>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <StyledTabs
          value={value}
          onChange={handleChange}
          aria-label="switch between model or VIN trade in search"
          variant="fullWidth"
        >
          <StyledTab label={<TabHeader>Model</TabHeader>} />
          <StyledTab label={<TabHeader>VIN</TabHeader>} />
        </StyledTabs>
      </Box>
      <TabPanel value={value} index={0}>
        <Suspense
          fallback={
            <YMMTFormContainer>
              <YMMTFormSkeleton />
            </YMMTFormContainer>
          }
        >
          <YMMTFormContainer>
            <YMMTForm onSubmit={handleOnSubmit} accountId={accountId} />
          </YMMTFormContainer>
        </Suspense>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <SearchByVIN onSubmit={handleOnSubmit} />
      </TabPanel>
    </Wrapper>
  );
};

export default Search;
